import React from "react";
import { StyleSheet } from "react-native";
import { layout } from "@/constants";
import IconButton from "./base/IconButton";
import { IconName } from "./base/Icon";

/**
 * Props for the HeaderButton component
 */
interface HeaderButtonProps {
  /** The icon name to display from Material Symbols */
  icon: IconName;
  /** Callback function triggered when the button is pressed */
  onPress: () => void;
  /** Accessibility label for screen readers */
  accessibilityLabel: string;
}

/**
 * A standardized header action: the borderless {@link IconButton} with the
 * brand accent tint and header padding. Kept as a named wrapper so header
 * call sites stay semantic and the header styling lives in one place.
 *
 * @param props - The component props
 * @returns An interactive icon button for headers
 */
export default function HeaderButton({
  icon,
  onPress,
  accessibilityLabel
}: HeaderButtonProps) {
  return (
    <IconButton
      icon={icon}
      onPress={onPress}
      accessibilityLabel={accessibilityLabel}
      color="accent"
      style={styles.button}
    />
  );
}

const styles = StyleSheet.create({
  button: {
    padding: layout.space.sm
  }
});
